import { render, staticRenderFns } from "./QuotationPriceHistoryForm.vue?vue&type=template&id=7426631a&"
import script from "./QuotationPriceHistoryForm.vue?vue&type=script&lang=js&"
export * from "./QuotationPriceHistoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports